import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Row , Col , ProgressBar , Button } from 'react-bootstrap';
import moment from 'moment';
import GeneratePDF from '../../../classes/pdf_generate.js';
import LanguageSelector from '../../inputs/language-selector.js';
import Toggle from '../../inputs/input.toggle.component.js';
import { Link , hashHistory } from "react-router";

class SavePrintable extends React.Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.state = { saved: true};
        this.PDFgen = new GeneratePDF();
    }

    componentDidMount() {
        var vocabs = this.props.data.selectedVocab || [];
        var printable = this.props.data.printable;
        var language = this.props.data.selectedLanguage;
        var level = this.props.data.level;

        switch (printable) {
             case "Word Search":

                 console.log(vocabs);
                this.PDFgen.generateWordSearch(vocabs, language, level).then(function(){
                    var ctx = document.getElementById("canvasPdf");
                    if (ctx != undefined && ctx != null) {
                        ctx.parentElement.removeChild(ctx);
                    }
                    hashHistory.push('dashboard');
                });
                break;
            case "Snap":
                this.PDFgen.generateSnapPDF(vocabs, language).then(function(){
                    var ctx = document.getElementById("canvasPdf");
                    if (ctx != undefined && ctx != null) {
                        ctx.parentElement.removeChild(ctx);
                    }
                    hashHistory.push('dashboard');
                });
                break;
            case "Flashcards":
                this.PDFgen.generateFlashcardPDF(vocabs, language).then(function(){
                    var ctx = document.getElementById("canvasPdf");
                    if (ctx != undefined && ctx != null) {
                        ctx.parentElement.removeChild(ctx);
                    }
                    hashHistory.push('dashboard');
                });
                break;
            case "Dice":
                this.PDFgen.generateDicePDF(vocabs, language).then(function(){
                    var ctx = document.getElementById("canvasPdf");
                    if (ctx != undefined && ctx != null) {
                        ctx.parentElement.removeChild(ctx);
                    }
                    hashHistory.push('dashboard');
                });
                break;
            case "Vocab List":
            default:
                this.PDFgen.generateVocabPDF(vocabs, language).then(function(){
                    var ctx = document.getElementById("canvasPdf");
                    if (ctx != undefined && ctx != null) {
                        ctx.parentElement.removeChild(ctx);
                    }
                    hashHistory.push('dashboard');
                });
                break;
        }
    }

    renderSaving(){
        return <div><Row><Col sm={2} smOffset={5} >
            <div className="preloader pl-xl pls-blue">
                <svg className="pl-circular" viewBox="25 25 50 50">
                    <circle className="plc-path" cx="50" cy="50" r="20"/>
                </svg>
            </div>
</Col>
        </Row></div>
    }

    renderSaved(){
        return <div></div>
    }

    render(){
         return this.renderSaving()
    }
}


export default {
    name: <FormattedMessage id={ 'ui-336' } defaultMessage={ 'Save' }/>,
    onSubmit: function (done){
        done();
    },
    component: SavePrintable
}


// WEBPACK FOOTER //
// ./src/components/wizard/printable-steps/save-printable.js